<template>
	<div>
		<h1>Title Page</h1>
		<InputTextSingleLine
			question="What is the title of the study?"
			:value="$tera.project.name"
			@input="$tera.project.name = $event"
			bookmark="title-study"
			placeholder="e.g. Blue-light therapy for acne vulgaris: a systematic review and meta-analysis"
		/>
		<InputTextSingleLine
			question="What is the short title for the study?"
			v-model="$tera.project.nameShort"
			placeholder="e.g. Blue-light"
			bookmark="short-title"
		/>
		<InputTextNumber
			question="What year will study be published?"
			v-model="$tera.project.year"
			bookmark="year-publication"
		/>
	</div>
</template>

<script>
export default {
	name: "ViewMethodPicot"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
